import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { theme } from 'utils/style/theme';
import { storyApi } from 'apis/story/storyApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import { IProjectDetail, IProject } from 'utils/types/storyTypes';
import OtomeProjectContent from './OtomeProjectContent';
import { useAppDispatch } from 'hooks/redux';
import { setStoryName } from 'store/slices/breadcumbSlice';
import addBtnIcon from 'utils/icon/icon_add-circle-blue.svg';
import FormRightContent from './OtomeProjectContent/FormRightContent';

/**
 * * 오토메 - 작품 정보 수정
 */

const OtomeProjectEditPage: React.FC = () => {
  const dispatch = useAppDispatch();

  const { projectId } = useParams();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [data, setData] = useState<IProject | null>(null);
  const [detailData, setDetailData] = useState<IProjectDetail[] | []>([]);
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const fetchDetailData = async () => {
    try {
      const dataRes = await storyApi.storyDetail(projectId);
      const langRes = await storyApi.supportLang();
      setData(dataRes.project);
      setDetailData(dataRes.project.projectDetails);
      setSupportLangList(langRes);
      dispatch(setStoryName(dataRes.project.title));
    } catch (err) {
      console.log('fecth data error:', err);
    }
  };

  useEffect(() => {
    fetchDetailData();
  }, []);

  const handleSubmit = async () => {
    console.log('submit');
  };

  const handleAddDetail = () => {
    const newRow: IProjectDetail = {
      lang: '',
      title: '',
      summary: null,
      writer: null,
      icon_url: null,
      icon_key: null,
      original: null,
      translator: null,
      icon_bucket: null,
    };

    const cloneDetailData = [...detailData, newRow];
    setDetailData(cloneDetailData);
  };

  return (
    <DefaultLayout>
      <InputFlexBox>
        {/* 다국어 */}
        <ListFormLeftWrapping>
          {detailData.map((el: IProjectDetail) => {
            return (
              <InputWrappingBox left>
                <OtomeProjectContent
                  key={el.id}
                  langList={supportLangList}
                  data={el}
                  listData={data}
                />
              </InputWrappingBox>
            );
          })}
        </ListFormLeftWrapping>

        <InputWrappingBox>
          <FormRightContent langList={supportLangList} data={data} />
        </InputWrappingBox>
      </InputFlexBox>
      <AddButton onClick={handleAddDetail}>
        <img src={addBtnIcon} alt='add' />
        <p>Create story for other language</p>
      </AddButton>
    </DefaultLayout>
  );
};

export default OtomeProjectEditPage;

const AddButton = styled.div`
  margin-top: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 6px;
  }
  p {
    color: ${theme.colors.blue_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;

const ListFormLeftWrapping = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;
`;
